export default "__VITE_ASSET__CsUpeso1__"